export enum StoreDesignPath {
    GENERATING = 'generating',
    TEMPLATES = 'templates'
}